import axios from 'axios';
import {Company} from '../models/Company';

// Environment variables with fallback values
const backendUrl = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:8000/api/v1';
const epayUrl = process.env.REACT_APP_EPAY_API_URL || 'https://api-sandbox.epaypolicy.com/api/v2/';
const publicKey = process.env.REACT_APP_EPAY_PUBLIC_KEY || '';
const impersonationKey = process.env.REACT_APP_EPAY_IMPERSONATION_KEY || '';

const backend =  axios.create({
  baseURL: backendUrl,
  headers : {
    accept: 'application/json'
  }
});

const epay =  axios.create({
  baseURL: epayUrl,
  headers : {
    Authorization: 'Api-Key ' + publicKey
  }
});

export async function getCompanyAndToken(term: string) {
  if (!term || term.trim() === '') {
    throw new Error('Term parameter is required');
  }
  return (await backend.get<Company[]>(`token/${encodeURIComponent(term.trim())}`)).data;
}

export async function getImpersonationTokenFromPolicyNumber(policyNumber: string) {

  if (!policyNumber || policyNumber.trim() === '') {
    throw new Error('Policy number parameter is required');
  }
  return (await backend.get<string>(`impersonation/${encodeURIComponent(policyNumber.trim())}`)).data;
}

export async function getInvoiceByNumber(invoiceNumber: string) {
  if (!invoiceNumber || invoiceNumber.trim() === '') {
    throw new Error('Invoice number parameter is required');
  }
  return (await backend.get<any>(`invoice/${encodeURIComponent(invoiceNumber.trim())}`)).data;
}

// Deprecated - kept for backward compatibility
export const getInvoiceByID = getInvoiceByNumber;

export async function getInvoicesByPolicyNumber(policyNumber: string) {
  if (!policyNumber || policyNumber.trim() === '') {
    throw new Error('Policy number parameter is required');
  }
  return (await backend.get<any[]>(`invoices/${encodeURIComponent(policyNumber.trim())}`)).data;
}

//get bank name from routing number routing_to_bank_name/:routing_number
export async function getBankName(routingNumber: string) {
  if (!routingNumber || routingNumber.trim() === '') {
    throw new Error('Routing number parameter is required');
  }
  return (await backend.get<any>(`routing_to_bank_name/${encodeURIComponent(routingNumber.trim())}`)).data;
}


export async function sendPayment(request: JSON) {
  return await backend.post(`payment`, request);
}

export async function getEpayToken(request: JSON, impersonationToken?: string) {
  const shouldImpersonate =
    !!impersonationToken && impersonationToken !== 'aebf5069f5024004a29cf06eb';
  const config = shouldImpersonate
    ? { headers: { impersonationAccountKey: impersonationToken } }
    : undefined;
  return await epay.post(`tokens`, request, config);
}

export async function validatePaymentSelection(payload: any) {
  return (await backend.post(`payment/validate`, payload)).data;
}

